import { render, staticRenderFns } from "./TerminalForm.vue?vue&type=template&id=4084cc24"
import script from "./TerminalForm.vue?vue&type=script&lang=ts"
export * from "./TerminalForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports